import {useApi} from '@/composables/useApi'

const api = useApi()

const PassWordService = {
    async ChangePassword(user_email) {
      try {
        const response = api.post('/redefirSenhaEmail', {user_email});
        return response;
      } catch (error) {
        throw new Error(error);
      }
    }
  };
  export default PassWordService;